export default "__VITE_ASSET__7dc766c8__"